module.exports = __webpack_public_path__ + "static/2018-73cb79f198bf754566bad49803e514cf.png";